"use strict";

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.reflect.construct");

require("core-js/modules/es6.object.assign");

var _classCallCheck = require("/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/getPrototypeOf");

require("core-js/modules/es6.object.define-property");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var React = tslib_1.__importStar(require("react"));

var focus_trap_1 = tslib_1.__importDefault(require("focus-trap"));

var FocusTrap = /*#__PURE__*/function (_React$Component) {
  _inherits(FocusTrap, _React$Component);

  var _super = _createSuper(FocusTrap);

  function FocusTrap(props) {
    var _this;

    _classCallCheck(this, FocusTrap);

    _this = _super.call(this, props);
    _this.divRef = React.createRef();

    if (typeof document !== 'undefined') {
      _this.previouslyFocusedElement = document.activeElement;
    }

    return _this;
  }

  _createClass(FocusTrap, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // We need to hijack the returnFocusOnDeactivate option,
      // because React can move focus into the element before we arrived at
      // this lifecycle hook (e.g. with autoFocus inputs). So the component
      // captures the previouslyFocusedElement in componentWillMount,
      // then (optionally) returns focus to it in componentWillUnmount.
      this.focusTrap = focus_trap_1["default"](this.divRef.current, Object.assign(Object.assign({}, this.props.focusTrapOptions), {
        returnFocusOnDeactivate: false
      }));

      if (this.props.active) {
        this.focusTrap.activate();
      }

      if (this.props.paused) {
        this.focusTrap.pause();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.active && !this.props.active) {
        var returnFocusOnDeactivate = this.props.focusTrapOptions.returnFocusOnDeactivate;
        var returnFocus = returnFocusOnDeactivate || false;
        var config = {
          returnFocus: returnFocus
        };
        this.focusTrap.deactivate(config);
      } else if (!prevProps.active && this.props.active) {
        this.focusTrap.activate();
      }

      if (prevProps.paused && !this.props.paused) {
        this.focusTrap.unpause();
      } else if (!prevProps.paused && this.props.paused) {
        this.focusTrap.pause();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.focusTrap.deactivate();

      if (this.props.focusTrapOptions.returnFocusOnDeactivate !== false && this.previouslyFocusedElement && this.previouslyFocusedElement.focus) {
        this.previouslyFocusedElement.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      var _a = this.props,
          children = _a.children,
          className = _a.className,
          focusTrapOptions = _a.focusTrapOptions,
          active = _a.active,
          paused = _a.paused,
          rest = tslib_1.__rest(_a, ["children", "className", "focusTrapOptions", "active", "paused"]);

      return React.createElement("div", Object.assign({
        ref: this.divRef,
        className: className
      }, rest), children);
    }
  }]);

  return FocusTrap;
}(React.Component);

exports.FocusTrap = FocusTrap;
FocusTrap.displayName = 'FocusTrap';
FocusTrap.defaultProps = {
  active: true,
  paused: false,
  focusTrapOptions: {}
};